import { NotificationBanner } from '@greystar/designsystem';
import { useAnalytics } from '@greystar/lib';
import { EventProperty } from '@greystar/lib/src/types/property-types';
import { Text as JssText, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState, JSX } from 'react';
import { InformationNotificationProps } from '../../component-props';

const InformationNotification = (props: InformationNotificationProps): JSX.Element => {
  const [isVisible, setIsVisible] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const { fields, params } = props;
  const analytics = useAnalytics();

  const property: EventProperty = props?.sitecoreContext?.property ?? {};
  const location = property?.location;

  const addressParts = location
    ? [location.address, location.city, location.state, location.postalCode].filter((part) =>
        part?.trim()
      )
    : [];

  useEffect(() => {
    const el = document.querySelector('[data-testid="search-input"]');
    const input = el instanceof HTMLInputElement ? el : null;
    const val = input?.value ?? '';
    setSearchValue(val);
  }, []);

  const property_location = addressParts.length > 0 ? addressParts.join(', ') : searchValue;

  // Return empty fragment if not visible or no text
  if (!isVisible || !fields?.text?.value) return <></>;

  // Determine if dismiss button should be shown
  const canDismiss = params?.canDismiss === '1';

  // Handle dismiss action
  const handleDismiss = () => {
    const eventData = {
      event: 'information',
      action_type: 'dismiss',
      state: location?.state ?? searchValue.split(',')[1]?.trim() ?? '',
      property_location: property_location,
      property_id: property.id ?? '',
      property_name: property.name ?? '',
      module_name: 'information text',
      inpage_location: 'top',
      click_text: fields.text.value ?? '',
      click_type: 'internal',
      destination_url: '',
    };
    analytics.trackEvent('information', eventData);
    setIsVisible(false);
  };

  return (
    <NotificationBanner
      text={<JssText field={fields.text} />}
      cta=""
      variant="info"
      iconName="Vertify"
      iconColour="secondary"
      radius={true}
      canDismiss={canDismiss}
      onCloseBanner={handleDismiss}
      bodyCopySize="medium"
    />
  );
};

export default withDatasourceCheck()<InformationNotificationProps>(InformationNotification);
